import {inject, Injectable, NgZone} from '@angular/core';
import {from, Observable} from 'rxjs';

declare var grecaptcha: any;

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {
  private zone = inject(NgZone);
  private siteKey = '6Lexs2QsAAAAAGrF41JhZL28rZjeUf95iQ8zkK80';

  getToken(action: string): Observable<string> {
    return new Observable<string>(observer => {
      grecaptcha.ready(() => {
        const promise = grecaptcha.execute(this.siteKey, {action});

        from(promise).subscribe({
          next: (token) => {
            this.zone.run(() => {
              observer.next(token as string);
              observer.complete();
            });
          },
          error: (err) => {
            this.zone.run(() => observer.error(err));
          }
        });
      });
    });
  }
}
